import * as angular from "angular";
import {IController} from "angular";
import {SplitService} from "../../services/split-service.service";

export class bringozEtaTooltipCtrl implements IController {

  eta: any;
  timeZoneId: string;
  configZoneId: string;

  private timeZoneOffsetDiff: number;

  /* @ngInject */
  constructor(private splitService: SplitService) {}

  $onInit() {
    this.checkTimeZoneOffsetDiff();
  }

  $onChanges(changes) {
    if (changes.eta && !changes.eta.isFirstChange()) {
      this.checkTimeZoneOffsetDiff();
    }

    if (changes.configZoneId && !changes.configZoneId.isFirstChange()) {
      this.checkTimeZoneOffsetDiff();
    }
  }

  checkTimeZoneOffsetDiff() {
    this.timeZoneOffsetDiff = this.splitService.getTimeZoneOffsetDiff(this.timeZoneId, this.eta);
    return this.timeZoneOffsetDiff !== 0;
  }
}
angular
  .module('bringoz.admin.commons')
  .component('bringozEtaTooltip', {
    bindings: {
      eta: '<',
      timeZoneId: '<',
      configZoneId: '<'
    },
    template: require('./bringoz-eta-tooltip.html').default,
    controller: bringozEtaTooltipCtrl
  });
